module.exports = __webpack_public_path__ + "img/西班牙站.7f80e8fb.png";